import React, { useState } from "react";
import { toast } from "react-toastify";
import { uploadJudokasFile } from "../../../services/competiteursServices";
import { FaFileImport } from "react-icons/fa";

const UploadDemoJudokasButton = ({ competitionId, refreshJudokas }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleImportDemo = async () => {
    setIsLoading(true);

    try {
      const response = await fetch("/competiteurs_demo.xlsx");
      const blob = await response.blob();
      const file = new File([blob], "competiteurs_demo.xlsx", {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      await uploadJudokasFile(competitionId, file);

      toast.success("Judokas démo importés avec succès !");
      refreshJudokas();
    } catch (error) {
      console.error("Erreur import démo :", error);
      toast.error("Erreur lors de l'importation des judokas de démo.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      onClick={handleImportDemo}
      disabled={isLoading}
      className="flex items-center gap-2 mb-4 bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-md shadow transition"
    >
      <FaFileImport className="text-sm" />
      {isLoading ? "Importation..." : "Ajouter des Judokas (Mode Démo)"}
    </button>
  );
};

export default UploadDemoJudokasButton;
